import { BaseEntity } from './base-entity';

export class PrimaryLegalEntity extends BaseEntity {
  code: string;
}
